import { render, staticRenderFns } from "./MiniEditDialog.vue?vue&type=template&id=f3afa784&scoped=true"
import script from "./MiniEditDialog.vue?vue&type=script&lang=ts"
export * from "./MiniEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MiniEditDialog.vue?vue&type=style&index=0&id=f3afa784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3afa784",
  null
  
)

export default component.exports